export const PATIENT_FILES_PAGE_THEME = 'indigo';

export const PATIENT_AVATAR_THEMES = [
    'indigo',
    'purple',
    'cyan',
    'success',
    'teal',
    'orange',
    'pink',
    'violet',
];

export const PATIENT_CONTACT_ICON_THEMES = {
    phone: 'cyan',
    cell: 'success',
    email: 'pink',
};

export const PATIENT_TOOLBAR_CHIP_THEMES = {
    patients: 'indigo',
    page: 'purple',
    filter: 'pink',
    all: 'teal',
};

export const getPatientAvatarTheme = (patientId, index = 0) => {
    if (!patientId) {
        return PATIENT_AVATAR_THEMES[index % PATIENT_AVATAR_THEMES.length];
    }

    let hash = 0;

    for (let i = 0; i < patientId.length; i += 1) {
        hash = patientId.charCodeAt(i) + ((hash << 5) - hash);
    }

    return PATIENT_AVATAR_THEMES[Math.abs(hash) % PATIENT_AVATAR_THEMES.length];
};
